import { UNIT_TRANSLATED } from '@enmon/commons';
import { Descriptions } from 'antd';
import { ImageUploadReview } from 'components/ImageUpload/ImageUploadReview';
import { Fragment, VFC } from 'react';
import { useReplaceMeterStore } from 'routes/meter_replacement/useStore';
import { FormattedMessage } from 'react-intl';
import { OldValuesDescriptions as messages } from '../messages';

export const OldValuesDescriptions: VFC = () => {
  const { replacementDate, oldSerialNumber, oldRegisterStates } = useReplaceMeterStore();

  return (
    <Descriptions
      bordered
      column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
      size="small"
      title={<FormattedMessage {...messages.title} />}
    >
      <Descriptions.Item label={<FormattedMessage {...messages.replacementDateAndTime} />} span={2}>
        {replacementDate?.format('DD.MM.YYYY HH:mm')}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.serialNumber} />}>{oldSerialNumber}</Descriptions.Item>

      {oldRegisterStates?.map((register, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          <Descriptions.Item
            label={<FormattedMessage {...messages.registerName} values={{ register: index + 1 }} />}
            span={1}
          >
            {register.name} ({register.fullObis ?? '-'})
          </Descriptions.Item>

          <Descriptions.Item label={<FormattedMessage {...messages.registerStatus} />} span={1}>
            {register.counter} {register.unit && UNIT_TRANSLATED[register.unit]}
          </Descriptions.Item>
          <Descriptions.Item label={<FormattedMessage {...messages.registerPhotos} />} span={2}>
            <ImageUploadReview fileList={register.photos} previewWidth={150} />
          </Descriptions.Item>
        </Fragment>
      ))}
    </Descriptions>
  );
};
